import { ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';

type SelectionRowTriggerProps = {
	label: string;
	displayText: string;
	placeholder?: string;
	onOpen: () => void;
	disabled?: boolean;
	id?: string;
};

/**
 * Retângulo (valor / placeholder) + bolinha para abrir modal de escolha.
 */
export function SelectionRowTrigger({
	label,
	displayText,
	placeholder = 'Selecione…',
	onOpen,
	disabled = false,
	id,
}: SelectionRowTriggerProps) {
	const shown = displayText.trim() ? displayText : placeholder;

	return (
		<div className="flex w-full min-w-0 flex-col gap-1 sm:flex-row sm:items-center sm:gap-3">
			<span className="shrink-0 text-[10px] font-black uppercase tracking-widest text-stone-400 sm:w-28">
				{label}
			</span>
			<div className="flex min-w-0 flex-1 items-center gap-2">
				<button
					type="button"
					id={id}
					disabled={disabled}
					onClick={onOpen}
					className={cn(
						'flex min-h-9 min-w-0 flex-1 items-center rounded-xl border border-stone-200 bg-stone-50 px-3 py-2 text-left text-xs font-bold text-stone-800 transition-colors',
						disabled
							? 'cursor-not-allowed opacity-60'
							: 'hover:border-stone-300 hover:bg-white',
					)}
				>
					<span
						className={cn(
							'truncate',
							!displayText.trim()
								? 'text-stone-400'
								: 'text-stone-900',
						)}
					>
						{shown}
					</span>
				</button>
				<button
					type="button"
					disabled={disabled}
					onClick={onOpen}
					title="Escolher"
					aria-label={`Abrir seleção: ${label}`}
					className={cn(
						'flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-stone-200 bg-white text-stone-600 shadow-sm transition-colors',
						disabled
							? 'cursor-not-allowed opacity-60'
							: 'hover:border-[#e11d74]/40 hover:bg-pink-50 hover:text-[#e11d74]',
					)}
				>
					<ChevronRight className="size-4" aria-hidden />
				</button>
			</div>
		</div>
	);
}
